// extracted by mini-css-extract-plugin
module.exports = {"UpturnCards":"qh8NH"};